import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { usererrors } from 'src/app/errors/usererrors';
import { CustomerSite } from 'src/app/Models/CustomerSite';
import { CustomerSiteAddress } from 'src/app/Models/CustomersiteAddress';
import { CustomerSiteContact } from 'src/app/Models/Customersitecontact';
import { CustomerinformationService } from 'src/app/Services/customerinformation.service';
import { CommonUtilities } from 'src/assets/js/common-utilities';
//import * as ace from "ace-builds";
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-c-customerinformation',
  templateUrl: './c-customerinformation.component.html',
  styleUrls: ['./c-customerinformation.component.css']
})
export class CCustomerinformationComponent implements OnInit {
//   _CustomerSiteform: FormGroup;
//   _CustomerAddressPickupform: FormGroup;
//   _CustomerAddressBillingform: FormGroup;
//   _CustomerContactPickform: FormGroup;
//   _CustomerContactInvoiceform: FormGroup;
//   _CustomerContactOutgoingform: FormGroup;
//   _CustomerSite: CustomerSite;
//   _Tempform: FormGroup
//   CustomersListGrid: any[];
//   selectedtab: number = 0;
//   selectedtab1: number = 0;
//   Contactselectedtab: number = 0
//   displayBasic: boolean;
//   _CompanyType: any[]
//   _CreditType: any[]
//   _AccquiredAgent: any[]
//   _ProductType: any[]
//   _BillingTo: any[]
//   _AddressType: any[]
//   _ContactAddressType: any[]
//   _FloorType: any[]
//   _Country: any[]
//   _State: any[]
//   _District: any[]
//   _Validation: any[]
//   _GSTStatus: any[]
//   ContactList: any
//   Addresslist: any
//   _GSTStatus_: any[]
//   _Basedon: any[]
//   _CustomerList: any[]
//   _PincodeLocation: any[]
//   pincodelocation: any[]
//   pincodelocation1: any[]
//   _PincodeLocation1: any[]
//   disablePinLocation: boolean = true
//   disablePinLocation1: boolean = true
//   _LastAddedDocument: File;
//   imageselect: any
//   _SelectedCreditType: any[] = []
//   CreditTypeCode: any
//   CustomerCode: string
//   CreditTypeName: string
//   ExistCustomer: any[]
//   @ViewChild("editor", { static: true }) private editor: ElementRef<HTMLElement>;
  constructor(private fb: FormBuilder, private utility: CommonUtilities, private router: Router, private _CustomerInformationService: CustomerinformationService, private _CustomExceptionService: CustomExceptionService) { }

  ngOnInit(): void {
//     this.utility.pageLoadScript();
//     this._CustomerSiteform = this.fb.group({
//       customercode: [],
//       customersitecode: [],
//       customersitename: [],
//       credittypecode: [],
//       credittypes: [],
//       acquiredbycode: [],
//       acquiredby: [],
//       billingtocode: [],
//       billingto: [],
//       productname: [],
//       producttypecode: [],
//       producttype: [],
//       gstin: [],
//       gstStatuscode: [],
//       gstStatus: [],
//       validationbasedoncode: [],
//       validationbasedon: [],
//       idNumber: [],
//       onBehalfOf: [],
//       gstValidationstatuscode: [],
//       gstValidationstatus: [],
//       googlelocation: [],
//       latitude: [],
//       longitude: [],
//       pickuplocationphotoURL: [],
//       pickuplocationphotoFORMFILE: [],
//       pickuplocationintime: [],
//       pickuplocationouttime: [],
//       pickuplocationobservations: [],
//       recordstatus: [],
//       createdby: [],
//       modifiedby: [],
//       createdon: [],
//       modifiedon: [],
//       accountingyear: [],
//       lstCustomerSiteAddress:[],
//       lstCustomerSiteContact:[],
//       customername:[],
//       companytypecode:[],
//       companytype:[],
//       tallyid:[],
//       pan:[],
//       billingcyclecode:[],
//       billingcycle:[],
//       istransportercode:[],
//       istransporter:[],
//       prequotestatuscode:[],
//       prequotestatus:[],
//       recordstatuscode:[]
//       // totalspendtime: []
//     });
//     this._CustomerAddressPickupform = this.fb.group({
//       addressid: [],
//       customersitecode: [],
//       addresstype: [],
//       address: [],
//       taluk: [],
//       pincode: [],
//       pincodelocation: [],
//       floortype: [],
//       addresstypecode:[]
//     });
//     this._CustomerAddressBillingform = this.fb.group({
//       addressid: [],
//       customersitecode: [],
//       addresstype: [],
//       address: [],
//       taluk: [],
//       pincode: [],
//       pincodelocation: [],
//       floortype: [],
//     });
//     this._CustomerContactPickform = this.fb.group({
//       contactid: [],
//       customersitecode: [],
//       contacttype: [],
//       contactperson: [],
//       designation: [],
//       department: [],
//       phoneno: [],
//       mobileno: [],
//       emailid: [],
//       faxno: [],
//     });
//     this._CustomerContactInvoiceform = this.fb.group({
//       contactid: [],
//       customersitecode: [],
//       contacttype: [],
//       contactperson: [],
//       designation: [],
//       department: [],
//       phoneno: [],
//       mobileno: [],
//       emailid: [],
//       faxno: [],
//     });
//     this._CustomerContactOutgoingform = this.fb.group({
//       contactid: [],
//       customersitecode: [],
//       contacttype: [],
//       contactperson: [],
//       designation: [],
//       department: [],
//       phoneno: [],
//       mobileno: [],
//       emailid: [],
//       faxno: [],
//     });
//     this._Tempform = this.fb.group({
//       companytype: [],
//       billingcycle: [],
//       customername: [],
//       sameaddress: []
//     })
//     this._CustomerInformationService.GetPageInitializeDetails().subscribe((result) => {

//       const resultJSON = JSON.parse(JSON.stringify(result));
//       console.log(resultJSON);
//       this._CreditType = resultJSON.lstCreditType
//       this._FloorType = resultJSON.lstFloorType
//       this._AccquiredAgent = resultJSON.lstAcquiredBy
//       this._ProductType = resultJSON.lstProductType
//       this._GSTStatus = resultJSON.lstGSTstatus
//       this._Basedon = resultJSON.lstValidationBasedOn
//       this._BillingTo = resultJSON.lstBillingTo
//       this._CustomerList = resultJSON.lstCustomer
//       this._PincodeLocation = resultJSON.lstPincodeLocation
//       this._PincodeLocation1 = resultJSON.lstPincodeLocation

//       // lstCustomer
//     }, error => { this._CustomExceptionService.handleError(error); }
//     );
//     // lstCustomer


  }

//   onDocumentSelect(event, document) {
//     this._LastAddedDocument = event.currentFiles[0];
//     this._CustomerSiteform.get("pickuplocationphoto").setValue(this._LastAddedDocument.name);


//     document.clear();

//   }
//   GetCreditType(event) {

//     var credittypearray = "";
//     var credittypename = "";
//     var selectedcredittype = event.value
//     for (var i = 0; i < selectedcredittype.length; i++) {
//       if (credittypearray == "") {
//         credittypearray = selectedcredittype[i].metasubcode;
//         credittypename = selectedcredittype[i].metasubdescription;
//       }
//       else {
//         credittypearray = credittypearray + "," + selectedcredittype[i].metasubcode;
//         credittypename = credittypename + "," + selectedcredittype[i].metasubdescription;
//       }

//     }
//     this.CreditTypeCode = credittypearray
//     this.CreditTypeName = credittypename
//     //  console.log("refv",selectedcredittype.metasubcode);

//   }
//   enterpincode(event) {
//     var PinCode = this._CustomerAddressPickupform.get("pincode").value;
//     if (PinCode.length == 6) {
//       this.disablePinLocation = false
//       this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);
//     }
//   }
//   enterpincode1(event) {
//     var PinCode1 = this._CustomerAddressBillingform.get("pincode").value;
//     if (PinCode1.length == 6) {
//       this.disablePinLocation1 = false
//       this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
//     }
//   }
//   OnChangePickupAddress(event) {
//     if (event.checked == true) {

//       this._CustomerAddressBillingform.controls['address'].setValue(this._CustomerAddressPickupform.controls['address'].value);
//       this._CustomerAddressBillingform.controls['pincode'].setValue(this._CustomerAddressPickupform.controls['pincode'].value);
//       this._CustomerAddressBillingform.controls['floortype'].setValue(this._CustomerAddressPickupform.controls['floortype'].value);
//       var PinCode1 = this._CustomerAddressPickupform.get("pincode").value;
//       this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
//       this.disablePinLocation1 = false
//       var demo = this._CustomerAddressPickupform.controls['pincodelocation'].value.pincodeLocation
//       this._CustomerAddressBillingform.controls['pincodelocation'].setValue(demo);


//     }
//     else {
//       this.disablePinLocation1 = true
//       this._CustomerAddressBillingform.reset();
//     }

//   }
//   onRowSelectPopup(event: any) {
//     this.displayBasic = false;
//     var row = event.data;
//     this.CustomerCode = row.customercode || 0
//     this._Tempform.controls['companytype'].setValue(row.companytype);
//     this._Tempform.controls['billingcycle'].setValue(row.billingcycle);
//     this._Tempform.controls['customername'].setValue(row.customername);


//     this._CustomerInformationService.GetById(this.CustomerCode).subscribe((result) => {

//       const resultJSON = JSON.parse(JSON.stringify(result));
//       console.log("update", resultJSON);

//       if (resultJSON.tranStatus.result == true && (resultJSON != null || resultJSON != undefined)) {
//         this._CustomerSiteform.setValue(resultJSON.customerSiteDetail);
//         this._CustomerAddressPickupform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0])
        
//       console.log("bh",resultJSON.customerSiteDetail.lstCustomerSiteAddress[0]) 
//         this.ExistCustomer = resultJSON.customerSiteDetail;
//       }
//       else {
//         this._CustomExceptionService.handleError(resultJSON.tranStatus.lstErrorItem[0].message);
//       }
//     }, error => { this._CustomExceptionService.handleError(error) })
//     //   if (!resultJSON.customerSiteDetail) {
//     //     return;
//     //   } else {
//     //     this._CustomerSiteform.setValue(resultJSON.customerSiteDetail);
//     //   }

//     // }, error => { this._CustomExceptionService.handleError(error); }
//     // );
//   }
//   formconverstion(C_Customer: CustomerSite, documents: File[]) {
//     let time = new Date();
//     const formData: FormData = new FormData();
//     //TimeStamp Add:
//     if (this._LastAddedDocument) {
//       formData.append('profilePic', this._LastAddedDocument, this._LastAddedDocument.name);
//       C_Customer.pickuplocationphotoURL = this._LastAddedDocument.name;
//     }
//     this._CustomerInformationService.UploadFile(formData, this._LastAddedDocument.name).subscribe((result) => {
//       const resutJSON = JSON.parse(JSON.stringify(result));
//       console.log("save", resutJSON)
//       if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
//         this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
//         // this.ManageCustomersList = resutJSON.lstCustomer
//       }
//       else {
//         this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
//       }
//     }, error => { this._CustomExceptionService.handleError(error) })
//   }
//   showdocumentDialog(document: FileUpload, position1: string) {

//   }
//   onDocumentClear() {

//   }
//   onSave() {
//     this._SelectedCreditType = this._CustomerSiteform.get("credittypecode").value
//     console.log("mm", this._SelectedCreditType);
//     if (this._CustomerSiteform.valid) {
//       this._CustomerSite = this._CustomerSiteform.value;

//       this._CustomerSite.customercode = this.CustomerCode
//       this._CustomerSite.acquiredbycode = this._CustomerSiteform.get("acquiredbycode").value.metasubcode;
//       this._CustomerSite.producttypecode = this._CustomerSiteform.get("producttypecode").value.metasubcode;
//       this._CustomerSite.billingtocode = this._CustomerSiteform.get("billingtocode").value.metasubcode;
//       this._CustomerSite.gstStatuscode = this._CustomerSiteform.get("gstStatuscode").value.metasubcode;
//       this._CustomerSite.gstStatus = this._CustomerSiteform.get("gstStatuscode").value.metasubdescription;
//       this._CustomerSite.validationbasedoncode = this._CustomerSiteform.get("validationbasedoncode").value.metasubcode;
//       this._CustomerSite.validationbasedon = this._CustomerSiteform.get("validationbasedoncode").value.metasubdescription;
//       this._CustomerSite.gstValidationstatuscode = "MSC00006"
//       this._CustomerSite.gstValidationstatus = ""
//       this._CustomerSite.credittypecode = this.CreditTypeCode
//       this._CustomerSite.credittypes = this.CreditTypeName
//       this._CustomerSite.recordstatus = "MSC00001"
//       this._CustomerSite.createdby = "Admin"
//       this._CustomerSite.modifiedby = "Admin"
//       this._CustomerSite.createdon = new Date()
//       this._CustomerSite.modifiedon = new Date()
//       this._CustomerSite.accountingyear = new Date().getFullYear()


//       // var ref= this._CustomerSiteform.get("credittypecode").value.metasubcode;

//       if (this._CustomerSite.lstCustomerSiteAddress == null) {
//         this._CustomerSite.lstCustomerSiteAddress = [] = []
//       }
//       if (this._CustomerSite.lstCustomerSiteContact == null) {
//         this._CustomerSite.lstCustomerSiteContact = [] = [];
//       }
//       // this._CustomerSite.lstCustomerSiteAddress.push(l_CustomerAddress)
//       // this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContact)

//       var l_CustomerAddress = new CustomerSiteAddress();
//       l_CustomerAddress.addressid = 0;
//       l_CustomerAddress.customersitecode = "";
//       l_CustomerAddress.addresstypecode = "PQT00031";
//       l_CustomerAddress.address = this._CustomerAddressPickupform.get("address").value;
//       l_CustomerAddress.taluk = this._CustomerAddressPickupform.get("pincodelocation").value.taluk;
//       l_CustomerAddress.pincode = this._CustomerAddressPickupform.get("pincode").value;
//       l_CustomerAddress.pincodelocation = this._CustomerAddressPickupform.get("pincodelocation").value.pincodeLocation;
//       l_CustomerAddress.floortypecode = this._CustomerAddressPickupform.get("floortype").value.metasubcode;
//       l_CustomerAddress.recordstatuscode = "MSC00001"
//       this._CustomerSite.lstCustomerSiteAddress.push(l_CustomerAddress)
//       var l_CustomerBillingAddress = new CustomerSiteAddress();
//       l_CustomerBillingAddress.addressid = 0;
//       l_CustomerBillingAddress.customersitecode = "";
//       l_CustomerBillingAddress.addresstypecode = "PQT00032";
//       l_CustomerBillingAddress.address = this._CustomerAddressBillingform.get("address").value;
//       l_CustomerBillingAddress.taluk = this._CustomerAddressBillingform.get("pincodelocation").value.taluk;
//       l_CustomerBillingAddress.pincode = this._CustomerAddressBillingform.get("pincode").value;
//       l_CustomerBillingAddress.pincodelocation = this._CustomerAddressBillingform.get("pincodelocation").value.pincodeLocation;
//       l_CustomerBillingAddress.floortypecode = this._CustomerAddressBillingform.get("floortype").value.metasubcode;
//       l_CustomerBillingAddress.recordstatuscode = "MSC00001"
//       this._CustomerSite.lstCustomerSiteAddress.push(l_CustomerBillingAddress)
//       var l_CustomerContact = new CustomerSiteContact();
//       l_CustomerContact.contactid = 0;
//       l_CustomerContact.customersitecode = "";
//       l_CustomerContact.contacttypecode = "PQT00034";
//       l_CustomerContact.contactperson = this._CustomerContactPickform.get("contactperson").value;
//       l_CustomerContact.designation = this._CustomerContactPickform.get("designation").value;
//       l_CustomerContact.department = this._CustomerContactPickform.get("department").value;
//       l_CustomerContact.phoneno = this._CustomerContactPickform.get("phoneno").value;
//       l_CustomerContact.mobileno = this._CustomerContactPickform.get("mobileno").value;
//       l_CustomerContact.emailid = this._CustomerContactPickform.get("emailid").value;
//       l_CustomerContact.faxno = this._CustomerContactPickform.get("faxno").value;
//       l_CustomerContact.recordstatuscode = "MSC00001";
//       this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContact)
//       var l_CustomerContactInvoice = new CustomerSiteContact();
//       l_CustomerContactInvoice.contactid = 0;
//       l_CustomerContactInvoice.customersitecode = "";
//       l_CustomerContactInvoice.contacttypecode = "PQT00035";
//       l_CustomerContactInvoice.contactperson = this._CustomerContactInvoiceform.get("contactperson").value;
//       l_CustomerContactInvoice.designation = this._CustomerContactInvoiceform.get("designation").value;
//       l_CustomerContactInvoice.department = this._CustomerContactInvoiceform.get("department").value;
//       l_CustomerContactInvoice.phoneno = this._CustomerContactInvoiceform.get("phoneno").value;
//       l_CustomerContactInvoice.mobileno = this._CustomerContactInvoiceform.get("mobileno").value;
//       l_CustomerContactInvoice.emailid = this._CustomerContactInvoiceform.get("emailid").value;
//       l_CustomerContactInvoice.faxno = this._CustomerContactInvoiceform.get("faxno").value;
//       l_CustomerContact.recordstatuscode = "MSC00001";
//       this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContactInvoice)
//       var l_CustomerContactOutgoing = new CustomerSiteContact();
//       l_CustomerContactOutgoing.contactid = 0;
//       l_CustomerContactOutgoing.customersitecode = "";
//       l_CustomerContactOutgoing.contacttypecode = "PQT00036";
//       l_CustomerContactOutgoing.contactperson = this._CustomerContactOutgoingform.get("contactperson").value;
//       l_CustomerContactOutgoing.designation = this._CustomerContactOutgoingform.get("designation").value;
//       l_CustomerContactOutgoing.department = this._CustomerContactOutgoingform.get("department").value;
//       l_CustomerContactOutgoing.phoneno = this._CustomerContactOutgoingform.get("phoneno").value;
//       l_CustomerContactOutgoing.mobileno = this._CustomerContactOutgoingform.get("mobileno").value;
//       l_CustomerContactOutgoing.emailid = this._CustomerContactOutgoingform.get("emailid").value;
//       l_CustomerContactOutgoing.faxno = this._CustomerContactOutgoingform.get("faxno").value;

//       l_CustomerContact.recordstatuscode = "MSC00001";
//       this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContactOutgoing)
//       // if (this._Tempvariable == 0) {
//       console.log("IN");


//       // this._Customer.companytypecode = this._Customerform.get("companytypecode").value.metasubcode;
//       // this._Customer.billingcyclecode = this._Customerform.get("billingcyclecode").value.metasubcode;
//       // this.onEd();
//       //this.onEd()
//       console.log("len",this.ExistCustomer)
//       if (this.ExistCustomer == null) {
//         this._CustomerInformationService.InsertCustomer(this._CustomerSite).subscribe((result) => {
//           const resutJSON = JSON.parse(JSON.stringify(result));
//           console.log("save", resutJSON)
//           if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
//             this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
//             // this.ManageCustomersList = resutJSON.lstCustomer
//             this.reset()
//           }
//           else {
//             this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
//           }
//         }, error => { this._CustomExceptionService.handleError(error) }
//         );
//       }
//       else if(this.ExistCustomer != null){
//         this._CustomerInformationService.UpdateCustomer(this._CustomerSite).subscribe((result) => {
//               const resutJSON = JSON.parse(JSON.stringify(result));
//               console.log("EDIT", resutJSON)
//               if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
//                 this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
//                 // this.reset()
//               }
//               else {
//                 this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
//               }
//             }, error => { this._CustomExceptionService.handleError(error) }
    
//             );
//       }



//       // }
//       // if (this._Tempvariable == 1) {
//       //   console.log("IN");

//       //   this._Customer.createdon = new Date();
//       //   this._Customer.createdby = "ADMIN";
//       //   this._Customer.modifiedby = "ADMIN";
//       //   this._Customer.modifiedon = new Date();
//       //   this._Customer.accountingyear = new Date().getFullYear();
//       //   this._Customer.companytypecode = this._Customerform.get("companytypecode").value.metasubcode;
//       //   this._Customer.billingcyclecode = this._Customerform.get("billingcyclecode").value.metasubcode;
//       //   this._Customer.recordstatuscode = this._Customerform.get("recordstatuscode").value.metasubcode;
//       //   // this.onEd();
//       //   this._CustomerService.UpdateCustomer(this._Customer).subscribe((result) => {
//       //     const resutJSON = JSON.parse(JSON.stringify(result));
//       //     console.log("EDIT", resutJSON)
//       //     if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
//       //       this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
//       //       this.ManageCustomersList = resutJSON.lstCustomer
//       //       this.reset()
//       //     }
//       //     else {
//       //       this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
//       //     }
//       //   }, error => { this._CustomExceptionService.handleError(error) }

//       //   );
//       // }
//     }

//   }
//   /*onEd() {
//     alert("test");
//     ace.config.set("fontSize", "14px");
//     ace.config.set('basePath', 'https://unpkg.com/ace-builds@1.4.12/src-noconflict');
//     const aceEditor = ace.edit(this.editor.nativeElement);
//     aceEditor.getSession().setMode("ace/mode/json");
//     var myObj = this._CustomerSite;
//     var myJSON = JSON.stringify(myObj);
//     aceEditor.session.setValue(myJSON);

//   }*/
//   reset() {

//   }
//   goBack(event) {
//     this.router.navigate(['/vCustomer']);
//   }
//   showBasicDialog() {
//     this.displayBasic = true;
//   }
}
